import { Text } from '@/shared/ui';
import type { CascaderOption } from '../helpers';
import { getColumnOptions } from '../utils/path-utils';
import { CascaderColumn } from './CascaderColumn';

type CascaderColumnsProps = {
  processedOptions: CascaderOption[];
  activePath: string[];
  selectedPaths: string[][];
  hoveredIndex: number[];
  multiple: boolean;
  onlyLeafSelectable: boolean;
  columnCount: number;
  onCheckboxToggle: (option: CascaderOption, level: number) => void;
  onNavigate: (option: CascaderOption, level: number) => void;
  onMouseEnter: (level: number, idx: number) => void;
  onMouseLeave: (level: number) => void;
};

export const CascaderColumns = ({
  processedOptions,
  activePath,
  selectedPaths,
  hoveredIndex,
  multiple,
  onlyLeafSelectable,
  columnCount,
  onCheckboxToggle,
  onNavigate,
  onMouseEnter,
  onMouseLeave,
}: CascaderColumnsProps) => {
  if (processedOptions.length === 0) {
    return (
      <div className="flex min-h-[60px] min-w-[160px] items-center justify-center p-4">
        <Text color="muted">選択肢がありません</Text>
      </div>
    );
  }

  return (
    <div className="flex max-h-[300px] gap-1" onWheel={(e) => e.stopPropagation()}>
      {Array.from({ length: columnCount }, (_, i) => i).map((level) => {
        const columnOptions = getColumnOptions(level, activePath, processedOptions);
        if (columnOptions.length === 0) return null;
        const isLastColumn = level === columnCount - 1;

        return (
          <CascaderColumn
            key={level}
            level={level}
            options={columnOptions}
            isLastColumn={isLastColumn}
            activePath={activePath}
            selectedPaths={selectedPaths}
            hoveredIndex={hoveredIndex}
            multiple={multiple}
            onlyLeafSelectable={onlyLeafSelectable}
            onCheckboxToggle={onCheckboxToggle}
            onNavigate={onNavigate}
            onMouseEnter={onMouseEnter}
            onMouseLeave={onMouseLeave}
          />
        );
      })}
    </div>
  );
};
